<section class="vc-admin-section">
  <header class="vc-admin-section__header">
    @if (sectionData.titleKey) {
      <h2 class="vc-admin-section__title">{{ sectionData.titleKey | translate }}</h2>
    }
    @if (sectionData.descriptionKey) {
      <p class="vc-admin-section__description">
        {{ sectionData.descriptionKey | translate }}
      </p>
    }
  </header>

  @if (sectionData.tabs && sectionData.tabs.length > 0) {
    <nav class="vc-admin-section__tabs" aria-label="Section tabs">
      @for (tab of sectionData.tabs; track tab.route) {
        <a
          class="vc-admin-section__tab"
          [routerLink]="resolveTabRoute(tab.route)"
          [routerLinkActive]="'vc-admin-section__tab--active'"
          [routerLinkActiveOptions]="{ exact: tab.exact !== false }"
        >
          <i [class]="tab.icon"></i>
          <span>{{ tab.labelKey | translate }}</span>
        </a>
      }
    </nav>
  }

  <div class="vc-admin-section__content vc-admin-content-scope">
    <router-outlet></router-outlet>
  </div>
</section>
